// extracted by mini-css-extract-plugin
module.exports = {"partner":"partner_partner_2BveS","show":"partner_show_TK4ek","hide":"partner_hide_2Z3lz","scrollBar":"partner_scrollBar_2Q6PT","bar":"partner_bar_2VMJR"};